import { render, staticRenderFns } from "./PlotConfigurator.vue?vue&type=template&id=765cf04c&scoped=true&"
import script from "./PlotConfigurator.vue?vue&type=script&lang=js&"
export * from "./PlotConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./PlotConfigurator.vue?vue&type=style&index=0&id=765cf04c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765cf04c",
  null
  
)

export default component.exports